const getSetting = (httpClient, params) => {
  return httpClient.get(`setting`, { params: params })
    .then(res => res.data)
}

const updateSetting = (httpClient, config) => {
  return httpClient.patch(`setting`, config)
    .then(res => res.data)
}



export default {
  getSetting,
  updateSetting,
}
